/* eslint-disable @typescript-eslint/naming-convention */
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IHttpBasicResponse, JsonApiResponse } from '@boxx/core';
import { IGmbRepository, ISetAuthCodePayload } from '@boxx/gmb-core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IGmbAnalytics, IGMBReviews, IStoreAnalytics } from '../contracts/IAnalitycs';
import { IGmbLocation } from '../contracts/ILocation';

@Injectable()
export class GmbRepository implements IGmbRepository {
  private readonly baseUrl = `${environment.apiUrl}/api/${environment.instanceName}/v1`;
  private readonly baseUrlV2 = `${environment.apiUrl}/api/json/v2`;
  private readonly baseUrlJson = `${environment.apiUrl}/api/json/v1`;

  constructor(private httpClient: HttpClient,) {}

  getLocation(): Observable<IHttpBasicResponse<IGmbLocation>> {
    return this.httpClient.get<IHttpBasicResponse<IGmbLocation>>(
      `${this.baseUrlV2}/gmb/get_location`
    );
  }

  getAnalytics(customFiler: any): Observable<IHttpBasicResponse<IGmbAnalytics>> {
    let params = new HttpParams();

    for (const key in customFiler) {
      if (customFiler.hasOwnProperty(key)) {
        params = params.append(key, customFiler[key]);
      }
    }

    const body = params.toString();

    return this.httpClient.post<IHttpBasicResponse<IGmbAnalytics>>(
      `${this.baseUrl}/gmb/analitycs`,
      body
    );
  }

  getGMBReviews(): Observable<IHttpBasicResponse<IGMBReviews>> {
    return this.httpClient.get<IHttpBasicResponse<IGMBReviews>>(
      `${this.baseUrl}/gmb/reviews`
    );
  }

  getStoreAnalytics(customFiler: any): Observable<IHttpBasicResponse<IStoreAnalytics>> {
    return this.httpClient.get<IHttpBasicResponse<IStoreAnalytics>>(
      `${this.baseUrlJson}/ganalytics/hostname_report?from=`+customFiler.from + '&end='+customFiler.end
      // `${this.baseUrlJson}/ganalytics/pagepath_report?from=`+customFiler.from + '&end='+customFiler.end
    );
  }

  getAccumulatedAnalytics(customFiler: any): Observable<IHttpBasicResponse<any>> {
    return this.httpClient.get<IHttpBasicResponse<any>>(
      `${this.baseUrlJson}/analytics/visits?from=`+customFiler.from + '&end='+customFiler.end+'&period=day'
    );
  }

  getAuthCode(accessToken: any, idToken: any): Observable<any> {

      // URL de la API de Google para obtener información del usuario
      const url = 'https://www.googleapis.com/oauth2/v3/userinfo';

      // Configuración de la solicitud HTTP
      const config = {
          headers: {
              'Authorization': `Bearer ${accessToken}`
          },
          params: {
              'id_token': idToken // Incluye el idToken como parámetro de consulta
          }
      };

    return this.httpClient.get<any>(
      url, config
    );
  }

  setAuthCode(payload: ISetAuthCodePayload) {
    const params = this.buildHttpParams(payload);
    return this.httpClient.post<JsonApiResponse<IGmbLocation[]>>(
      `${environment.apiUrl}/api/json/v1/gauth/set_code`,
      params
    );
  }

  setSelectedLocation(payload: IGmbLocation) {
    return this.httpClient.post<JsonApiResponse<IGmbLocation>>(
      `${environment.apiUrl}/api/json/v1/gauth/choose`,
      JSON.stringify(payload)
    );
  }

  getGMBCategories(query: string): Observable<JsonApiResponse<JsonApiResponse<any>>> {
    return this.httpClient.get<JsonApiResponse<JsonApiResponse<any>>>(
      `${environment.apiUrl}/api/json/v2/gmb/get_categories?s=${query}`,
    );
  }

  createGBP(payload: any): Observable<any> {
    return this.httpClient.post<JsonApiResponse<any>>(
      `${environment.apiUrl}/api/json/v2/gmb/create`,
      JSON.stringify(payload)
    );
  }

  verifyGBP(payload: any): Observable<any> {
    return this.httpClient.post<JsonApiResponse<any>>(
      `${environment.apiUrl}/api/json/v2/gmb/verify`,
      JSON.stringify(payload)
    );
  }

  private buildHttpParams(payload: any) {
    let params = new HttpParams();

    for (const key in payload) {
      if (payload.hasOwnProperty(key)) {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        typeof payload[key] === 'object'
          ? (params = params.append(key, JSON.stringify(payload[key])))
          : (params = params.append(key, escape(payload[key])));
      }
    }
    return params;
  }

  private buildUrlSearchParams(payload: any) {
    const params = new URLSearchParams();

    for (const key in payload) {
      if (payload.hasOwnProperty(key)) {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        typeof payload[key] === 'object'
          ? params.set(key, JSON.stringify(payload[key]))
          : params.set(key, payload[key]);
      }
    }
    return params;
  }
}
